import { Navigate } from "react-router-dom";
import { Form, Row, Spinner } from "react-bootstrap";
import "@/pages/FormMenu/index.css";
import { AddEditModal } from "@/components";
import AddressBar from "@/components/Layout/AddressBar";
import AddFormField from "./addFormFields";
import AddFormMetaSection from "./AddFormMetaSection";
import AddFormResponseNotificationSection from "./AddFormResponseNotificationSection";
import AddFormSubmitMessageSection from "./AddFormSubmitMessageSection";
import AddFormFieldsTableSection from "./AddFormFieldsTableSection";
import useAddForm from "./useAddForm";

const AddForm = () => {
  const {
    guardRedirect,
    loading,
    formIds,
    navigate,
    testId,
    state,
    setState,
    userRole,
    name,
    status,
    is_public,
    accessLevel,
    description,
    email_displayed,
    email_required,
    responseNotification,
    emails,
    isEmailInvalid,
    alreadyExistsEmail,
    submit_message,
    submitMessageLoading,
    savedData,
    formModal,
    isEdit,
    isDisabledFormField,
    informationModalDisplay,
    informationEditorContent,
    isSubmitLoading,
    isDisabled,
    switchBtnColor,
    inputRef,
    informationRef,
    labelNameRef,
    handleChange,
    handleOnChangeSelect,
    handleEmailDisplayed,
    handleEmailRequired,
    handleResponseNotification,
    handleInputChange,
    removeEmail,
    handleEditorInit,
    handleFileChange,
    handleDragEndDataForSavedData,
    handleChildFormModal,
    handleFormFieldUpdate,
    handleFormFieldDelete,
    handleFormModal,
    handleSubmitForm,
    handleFormField,
    handleOnSubmitOptions,
    handleOnPressCancel,
    handleDragEndData,
    hideShowInformationModal,
    closeFormModal,
  } = useAddForm();

  if (guardRedirect) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <>
      <AddressBar
        page={[
          { name: "Forms", link: "/forms" },
          { name: !formIds ? "Add-Form" : "Edit-Form" },
        ]}
      />
      {loading ? (
        <div className="center" style={{ height: window.innerHeight - 250 }}>
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="row p-2 m-0 Bg-fff rounded mt-2 Shadow">
          <Form onSubmit={handleSubmitForm}>
            <Form.Group className="mb-3">
              <AddFormMetaSection
                testId={testId}
                name={name}
                status={status}
                is_public={is_public}
                accessLevel={accessLevel}
                userRole={userRole}
                description={description}
                email_displayed={email_displayed}
                email_required={email_required}
                handleChange={handleChange}
                handleOnChangeSelect={handleOnChangeSelect}
                switchBtnColor={switchBtnColor}
                handleEmailDisplayed={handleEmailDisplayed}
                handleEmailRequired={handleEmailRequired}
              />
              <AddFormResponseNotificationSection
                responseNotification={responseNotification}
                handleChange={handleChange}
                handleResponseNotification={handleResponseNotification}
                switchBtnColor={switchBtnColor}
                inputRef={inputRef}
                handleInputChange={handleInputChange}
                isEmailInvalid={isEmailInvalid}
                alreadyExistsEmail={alreadyExistsEmail}
                emails={emails}
                removeEmail={removeEmail}
              />
              <AddFormSubmitMessageSection
                submitMessageLoading={submitMessageLoading}
                submit_message={submit_message}
                handleEditorInit={handleEditorInit}
                handleFileChange={handleFileChange}
              />
              <AddFormFieldsTableSection
                savedData={savedData}
                handleDragEndDataForSavedData={handleDragEndDataForSavedData}
                handleChildFormModal={handleChildFormModal}
                handleFormFieldUpdate={handleFormFieldUpdate}
                handleFormFieldDelete={handleFormFieldDelete}
                testId={testId}
                handleFormModal={handleFormModal}
                isSubmitLoading={isSubmitLoading}
                isDisabled={isDisabled}
                handleSubmitForm={handleSubmitForm}
                onCancel={() => navigate("/forms")}
              />
            </Form.Group>
            <div>
              <Row>
                {formModal && (
                  <AddEditModal
                    id={`${testId}`}
                    name="Element"
                    show={formModal}
                    onSubmit={handleFormField}
                    type={isEdit ? "Edit" : "Add"}
                    isDisableSave={isDisabledFormField}
                    closeModal={closeFormModal}
                    className={`${informationModalDisplay}`}
                  >
                    <AddFormField
                      state={state}
                      setState={setState}
                      handleChange={handleChange}
                      handleOnSubmitOptions={handleOnSubmitOptions}
                      handleOnPressCancel={handleOnPressCancel}
                      handleDragEndData={handleDragEndData}
                      id={`${testId}Modal`}
                      ref={informationRef}
                      labelNameRef={labelNameRef}
                      content={informationEditorContent}
                      hideShowModal={hideShowInformationModal}
                    />
                  </AddEditModal>
                )}
              </Row>
            </div>
          </Form>
        </div>
      )}
    </>
  );
};
export default AddForm;
